import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { articles } from "@/mocks/articles";

const analysis = articles.filter((item) => item.type === "analysis").slice(0, 3);

export default function AnalysisSection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <SectionHeading
        eyebrow="Analysis"
        title="热门剧情解析"
        description="从符号、时间与视听语言出发，重新读懂经典影片。"
        linkTo="/features/plot-analysis"
        linkLabel="进入专题"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {analysis.map((item, index) => (
          <Link
            key={item.id}
            to="/features/plot-analysis"
            className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
          >
            <div className="relative w-full h-44 md:h-52 overflow-hidden bg-background-200">
              <img
                src={item.cover}
                alt={item.title}
                title={`${item.title} - 剧情解析`}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 w-8 h-8 rounded-md bg-background-50/90 text-accent-600 flex items-center justify-center font-heading font-semibold text-sm">
                {String(index + 1).padStart(2, "0")}
              </span>
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs">
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-400">{item.date}</span>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 line-clamp-3 leading-relaxed">
                {item.excerpt}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}